import React, { Component } from 'react'
import { Subscribe } from "unstated";
import StateContainer from "../../../state/StateContainer";

import "./CustomButtonArray.css"

import CustomButton from "../CustomButton/CustomButton"

class CustomButtonArray extends Component {
    state = {  }
    render() { 
        return (
          <Subscribe to={[StateContainer]}>
            {(state2) => (
              <div className="custom-button-array">
                {state2.state.customButtons
                  ?.filter((button) => !button.isDefault) //TODO: namestiti da se filtrira po tome da je prva akcija state i default = true
                  .map((button) => {
                    return (
                      <CustomButton
                        key={button.name}
                        buttonName={button.name}
                        buttonData={button}
                        buttonClass="custom-button"
                      />
                    );
                })}
              </div>
            )}
          </Subscribe>
        );
    }
}
 
export default CustomButtonArray;